import { call, put, takeEvery } from 'redux-saga/effects';
import normalize from 'jsonapi-normalizer';

import { wealthBalance }  from '../../../api';
import { resourceReducer } from '../../utils/resourceReducer';

// Create actions and a reducer for the wealthBalance resource
export const [actions, reducer, resourceSagas] = resourceReducer('balance-entries');

// Create the sagas for this entity
function* readWealthBalance() {
  yield takeEvery(actions.indexRequestBegin, function*() {
    try {
      const result = yield call(wealthBalance.get);
      const normalized = normalize(result);
      yield put(actions.indexRequestSuccess(normalized));
    } catch (error) {
      yield put(actions.indexRequestFailure({ error }));
      yield put({ type: 'ERRORS/HANDLE_API_ERROR', payload: error })
    }
  });
}

export const sagas = [readWealthBalance, ...resourceSagas];
